export default {
  app: {
    golf: {
      title: 'Informações do campo',
      hasEVChargingPoint: 'Ponto de carregamento EV',
      hasCaddieService: 'Serviço de caddie',
      hasTrolley: 'Carrinho',
      hasBuggy: 'Buggy',
      hasClubRental: 'Aluguer de tacos',
      hasAcademy: 'Academia',
      hasMarshal: 'Marshal',
      hasPGACertification: 'Certificação PGA',
      hasTrainingArea: 'Área de treino',
      hasRestaurant: 'Restaurante',
      hasHotel: 'Hotel',
      hasDogsOnCourse: 'Cães no campo',
      numberOfHoles: 'Número de buracos',
    },
  },
};
